const mapEmployeeTypeToLabel = (employeeType: string) => {
    const employeeTypeMap: Record<string, string> = {
        ExcludingManagers: "Medarbetare",
        Managers: "Chefer",
        All: "Samtliga",
    }

    return employeeTypeMap[employeeType] ?? employeeType
}

export default mapEmployeeTypeToLabel